import { getUsersProfile } from '../../../../api/users';

//Components
import AddProfile from '../../components/AddProfile';
import EditIcon from '../components/EditIcon';
import ProfileAvatar from '../components/ProfileAvatar';

export default function (page) {
  return getUsersProfile().then(({ data }) => {
    const { profiles } = data.user;
    const items = profiles.map((profile, index) => ({
      type: ProfileAvatar,
      collision: true,
      index,
      w: 254,
      h: 254,
      src: profile.avatar?.url,
      title: profile.first_name ?? '',
      data: {
        id: profile.id,
        autoplay: profile.autoplay,
      },
      EditIcon: {
        type: EditIcon,
        src: '/images/edit-icon.png',
      },
    }));

    profiles.length < 5 &&
      items.push({
        collision: true,
        index: profiles.length,
        type: AddProfile,
        w: 254,
        h: 254,
        src: 'images/my-list.svg',
        title: 'Add Profile',
        data: {
          id: 0,
        },
      });

    page._Profiles.items = items;
  });
}
